import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/members/login-failed-count";

export const loginFailedCount = {
    delete(data) {
        return axios.delete(url, data).then((result) => result.data);
    },
};
